import { Table as TableAnt } from 'antd';
import { TableProps } from 'antd/lib';
import { DocumentType } from '../interfaces';
import styled from '@emotion/styled';

export const Table = styled((props: TableProps<DocumentType>) => (
  <TableAnt {...props} />
))`
	border: none;
	border-radius: 10px;

	thead {
		background-color: transparent
	}

  td {
    padding-left: 0 !important;
  }

	.ant-pagination-item-active {
		border-color: none;
	}

	.ant-pagination {
		padding: 0 1rem;
		align-items: center;
	}

	.ant-pagination-total-text {
		margin-right: auto;
	}

	.ant-table-row:last-of-type {
		.ant-table-cell {
			border-bottom: none;
		}
	}

	.ant-table-selection-column {
		padding-inline-end: 5px !important;
		padding-inline-start: 20px !important;

		.ant-checkbox:not(.ant-checkbox-indeterminate) {
			.ant-checkbox-inner {
				width: 24px !important;
				height: 24px !important;
				border-radius: 5px !important;

				&::after {
					width: 7px !important;
					height: 12px !important;
					top: 47% !important;
					inset-inline-start: 30% !important;
				}
			}
		}
		.ant-checkbox-indeterminate {
			.ant-checkbox-inner {
				width: 24px !important;
				height: 24px !important;
				border-radius: 5px !important;

				&::after {
					width: 13px !important;
					height: 13px !important;
				}
			}
		}
	}
`;
